<template>
  <Default class="view-contacts">
    <div class="container">
      <FormForgotPassword />
    </div>
  </Default>
</template>
<script setup>
import Default from "@/layouts/Default.vue";
import FormForgotPassword from "@/components/form/FormForgotPassword.vue";
import { onMounted } from "vue";
import { setLanguageParameter } from "@/composables/language.js";

onMounted(() => {
  setLanguageParameter();
});
</script>

<style lang="postcss" scoped>
.reset-container {
  @apply w-full;
}

@screen md {
  .reset-container {
    @apply w-1/2 mx-auto;
  }
}

.reset-form {
  @apply w-full;
}

@screen md {
  .reset-form {
    @apply w-full;
  }
}
</style>